/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_JumpInputs */

const fr_rapid_eager_otter_jump = /** @type {(inputs: Rapid_Eager_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jours`)
};

/**

* @param {Rapid_Eager_Otter_JumpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_jump = /** @type {((inputs?: Rapid_Eager_Otter_JumpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_JumpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_jump(inputs)
});